@use "variables" as *;

.avatar {
  width: 36px !important;
  height: 36px !important;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
}

.name {
  font-size: $fontSize-m;
  font-weight: bold;
  align-self: center;
  word-wrap: anywhere;
  border-width: 2px;
}

.card {
  justify-content: flex-start !important;
  min-width: 120px;
  min-height: 50px;
  height: 100%;
}
